module.exports = __webpack_public_path__ + "static/media/dropoutStudy.6e6f3248.pdf";